/* esm.sh - esbuild bundle(micromark-util-normalize-identifier@1.0.0) deno production */
function r(e){return e.replace(/[\t\n\r ]+/g," ").replace(/^ | $/g,"").toLowerCase().toUpperCase()}export{r as normalizeIdentifier};
//# sourceMappingURL=micromark-util-normalize-identifier.js.map